import React, { useMemo } from "react";
import { Box, Grid, TextField } from "@mui/material";
import { toISO, addDaysISO, daysBetween } from "./utils";

export default function DateRow({ start, end, onChange, ensureQty }) {
  const minToday = toISO(new Date());

  const computedDays = useMemo(
    () => (start && end ? daysBetween(start, end) : 0),
    [start, end]
  );

  const hasBoth = Boolean(start && end);
  const invalid = hasBoth && computedDays <= 0;

  const handleStart = (s) => {
    const nextEnd = !end || daysBetween(s, end) <= 0 ? addDaysISO(s, 1) : end;
    onChange({
      startDate: s,
      endDate: nextEnd,
      days: daysBetween(s, nextEnd),
      quantity: ensureQty?.(1),
    });
  };

  const handleEnd = (e2) => {
    const s2 = start || addDaysISO(e2, -1);
    onChange({
      startDate: s2,
      endDate: e2,
      days: daysBetween(s2, e2),
      quantity: ensureQty?.(1),
    });
  };

  return (
    <Box sx={{ mt: 1.25 }}>
      <Grid container spacing={1.25}>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            type="date"
            size="small"
            label="Pickup"
            value={start || ""}
            InputLabelProps={{ shrink: true }}
            inputProps={{ min: minToday }}
            onChange={(e) => handleStart(e.target.value)}
            sx={{ "& .MuiInputBase-root": { borderRadius: 2 } }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            type="date"
            size="small"
            label="Return"
            value={end || ""}
            InputLabelProps={{ shrink: true }}
            inputProps={{ min: start || minToday }}
            error={invalid}
            helperText={
              hasBoth
                ? invalid
                  ? "Return must be after pickup"
                  : `${computedDays} day${computedDays > 1 ? "s" : ""}`
                : " "
            }
            onChange={(e) => handleEnd(e.target.value)}
            sx={{ "& .MuiInputBase-root": { borderRadius: 2 } }}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
